import { render, staticRenderFns } from "./CultureIndex.vue?vue&type=template&id=73002526&scoped=true"
import script from "./CultureIndex.vue?vue&type=script&lang=js"
export * from "./CultureIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73002526",
  null
  
)

export default component.exports